import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';
import Repeater from '@Utils/Repeater';
import { BookView } from '@Selectors/publication/book/view/book.view';
import BookComponent from '@Components/publication/book/book.component';
import { booksPresenter } from '@Selectors/publication/book/show/books.presenter';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

const MyBooksComponent: React.FC<Props> = ({books}) => {
  if (books.length === 0) {
    return (<div/>);
  }

  return (
    <section>
      <h2><FormattedMessage {...defaultMessages.publicationBooksIndexTitle} /></h2>
      <div className="content row justify-content-center">
        <Repeater data={books} indexPrefix='arsenal-army'>
          {
            (item: BookView) => <BookComponent book={item}/>
          }
        </Repeater>
      </div>
    </section>
  );
};

const mapStateToProps = (state: AppState) => ({
  books: booksPresenter(state),
})

const mapDispatchToProps = (_: Dispatch) => ({})

export default  connect(mapStateToProps, mapDispatchToProps)(MyBooksComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
